import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=94fb35cc&scoped=true&"
import script from "./Attachment.vue?vue&type=script&lang=js&"
export * from "./Attachment.vue?vue&type=script&lang=js&"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=94fb35cc&scoped=true&lang=css&"
import style1 from "./Attachment.vue?vue&type=style&index=1&id=94fb35cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fb35cc",
  null
  
)

export default component.exports